/**
 * Block 6 (2026-05-26): Accounting Constants Reference API.
 */
import { api } from './client';


export interface ConstantSnapshot {
  code: string;
  value: string;
  description: string;
  unit: string;
  source: string;
  effective_from: string;
}

export interface ConstantRange {
  effective_from: string;
  value: string;
  description: string;
  unit: string;
  source: string;
}

export interface ConstantHistory {
  code: string;
  ranges: ConstantRange[];
}

export type DerivedCategory = 'AT_DATE' | 'SNAPSHOT_YEAR_START';

export interface DerivedValue {
  code: string;
  value: string;
  formula: string;
  source_constants: string[];
  legal_reference: string;
  description: string;
  unit: string;
  category: DerivedCategory;
  at_date_used: string;
}


const BASE = '/refs/accounting-constants';


export const accountingConstants = {
  list: (at_date?: string) =>
    api.get<ConstantSnapshot[]>(BASE, {
      params: at_date ? { at_date } : undefined,
    }).then((r) => r.data),

  history: (code: string) =>
    api.get<ConstantHistory>(`${BASE}/history/${code}`).then((r) => r.data),

  derived: (at_date?: string) =>
    api.get<DerivedValue[]>(`${BASE}/derived`, {
      params: at_date ? { at_date } : undefined,
    }).then((r) => r.data),
};
